/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HandThumbUpIcon16Light } from './HandThumbUpIcon16Light';
import { HandThumbUpIcon16Regular } from './HandThumbUpIcon16Regular';
import { HandThumbUpIcon16Solid } from './HandThumbUpIcon16Solid';
import { HandThumbUpIcon20Light } from './HandThumbUpIcon20Light';
import { HandThumbUpIcon20Regular } from './HandThumbUpIcon20Regular';
import { HandThumbUpIcon20Solid } from './HandThumbUpIcon20Solid';
import { HandThumbUpIcon24Regular } from './HandThumbUpIcon24Regular';
import { HandThumbUpIcon24Solid } from './HandThumbUpIcon24Solid';
import { HandThumbUpIcon32Regular } from './HandThumbUpIcon32Regular';
import { HandThumbUpIcon64Regular } from './HandThumbUpIcon64Regular';
var sizes = {
    16: {
        light: HandThumbUpIcon16Light,
        regular: HandThumbUpIcon16Regular,
        solid: HandThumbUpIcon16Solid,
    },
    20: {
        light: HandThumbUpIcon20Light,
        regular: HandThumbUpIcon20Regular,
        solid: HandThumbUpIcon20Solid,
    },
    24: {
        regular: HandThumbUpIcon24Regular,
        solid: HandThumbUpIcon24Solid,
    },
    32: {
        regular: HandThumbUpIcon32Regular,
    },
    64: {
        regular: HandThumbUpIcon64Regular,
    },
};
export var HandThumbUpIcon = forwardRef('HandThumbUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
